import useLxLocation from "./LocationHook";

/**
 * A custom hook that provides the means to parse the query string for you. <br/>
 *
 * @package Utils
 * @example
 * const query = useLxQuery();
 * const myQueryParamValue = query.get("myQueryParam");
 */
export function useLxQuery() {
  return new URLSearchParams(useLxLocation().search);
}
